import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD, HREF_FIELD } from "../commonFields";

export const onPageRailNavigationBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "OnPage rail navigation",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  canHaveChildren: true,
  inputs: [
    {
      name: "navType",
      type: "enum",
      enum: ["flat", "nested"],
      defaultValue: "flat",
      helperText:
        "Flat style combines all items into a single content, nested style allows tabbing between sections.",
    },
    { name: "navItemsHeadline", type: "string", localized: true },
    {
      name: "navItems",
      type: "list",
      subFields: [
        {
          name: "id",
          type: "string",
          helperText:
            "Unique identifier for the item. Preferably set the href field instead.",
        },
        {
          name: "name",
          type: "string",
          required: true,
          helperText: "Text to display for the item.",
        },
        HREF_FIELD,
        DLT_FIELD,
        DLD_FIELD,
        {
          name: "subItems",
          type: "list",
          subFields: [
            {
              name: "name",
              type: "string",
              required: true,
              helperText: "Text to display for the item.",
            },
            HREF_FIELD,
            DLT_FIELD,
            DLD_FIELD,
          ],
        },
        {
          name: "blocks",
          type: "uiBlocks",
          localized: false,
          defaultValue: [],
        },
      ],
      defaultValue: [
        {
          id: "section-1",
          name: "Section 1",
          href: { type: "internal", url: "#section-1" },
          blocks: [
            {
              "@type": "@builder.io/sdk:Element",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Tab 1 Content",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                },
              ],
            },
          ],
        },
        {
          id: "section-2",
          name: "Section 2",
          href: { type: "internal", url: "#section-2" },
          blocks: [
            {
              "@type": "@builder.io/sdk:Element",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Tab 2 Content",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
